/**
 * The single seam between auth and API calls. Auth providers (MSAL, dev
 * personas, tests) register a token getter; the API client calls it per request.
 */

type TokenProvider = () => Promise<string | null>;
let tokenProvider: TokenProvider | null = null;

export function setTokenProvider(provider: TokenProvider | null): void {
  tokenProvider = provider;
}

export async function getAccessToken(): Promise<string | null> {
  return tokenProvider ? tokenProvider() : null;
}
